import { render, staticRenderFns } from "./CreateImportModal.vue?vue&type=template&id=dd162d1c&"
import script from "./CreateImportModal.vue?vue&type=script&lang=js&"
export * from "./CreateImportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports